export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas por cobrar"])},
          "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resumen de facturas por cobrar a clientes"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver detalles"])},
          "currency": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moneda"])},
          "total_num_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["# Facturas"])},
          "percent_receivable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["% Cobrado"])},
          "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto total"])},
          "total_amount_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto cobrado"])},
          "chart_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["% cobrado"])},
          "receivable": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Por cobrar"])}
        }
      }
    }
  })
}